module.exports = __webpack_public_path__ + "img/peering-manager-logo-white.a369d59f.png";